module.exports = __webpack_public_path__ + "static/media/industries.fe92d4b5.jpg";